<template>
    <q-layout>
        <q-page-container>
            <ClientTransaction />
        </q-page-container>
    </q-layout>
</template>

<script>
import ClientTransaction from '@/components/ClientTransactionScreenSwitching.vue'
import { mapState, mapActions } from "vuex";
import store from '../store';
export default {
  name: 'clienttransaction',
  components: { 
    ClientTransaction
  },
  data () {
    return {
      StoreStateLookup : store.state.Lookup,
      StoreStateProduct : store.state.Product
    }
  },
  mounted(){
   //   this.GetListOfFund();
    
  },
  methods : {
    ...mapActions(["GetListOfFund"])
  }
}
</script>